// The root layout reads both cookies; the rest stays with `OrganisationProvider`.
export {
  LAST_ORGANISATION_COOKIE_NAME,
  ORG_COOKIE_NAME,
  type OrganisationCookies,
  readOrganisationCookies,
} from './cookies.ts'
export * from './organisation-provider.tsx'
